var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer-form-container"},[_c('div',{staticClass:"page-header"},[_c('h2',[_vm._v(_vm._s(_vm.isEdit ? '编辑客户' : '新增客户'))])]),_c('el-card',[_c('customer-form',{attrs:{"customer-id":_vm.customerId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }